<div class="edit-whatsapp-dialog">
    <div class="edit-whatsapp-dialog__header">
        <h3>{{ data.title }}</h3>
        <dsn-button-rounded
            type="secondary"
            icon="fa-solid fa-xmark"
            size="medium"
            (click)="onClose()"
        ></dsn-button-rounded>
    </div>
    <div class="edit-whatsapp-dialog__content">
        <p class="edit-whatsapp-dialog__content-description">
            Este contato será utilizado caso o seu cliente queira conversar
            sobre os <strong>dashes enviados por WhatsApp</strong>.
        </p>
        <div fxLayout="row" class="gap-8">
            <dsn-select
                placeholder="DDDI"
                [value]="defaultValue"
                [disabled]="loading"
            >
                @for (prefix of prefixes; track $index) {
                    <dsn-option
                        [value]="prefix.value"
                        (onClick)="onChangeDDI(prefix.value)"
                        >{{ prefix.label }}</dsn-option
                    >
                }
            </dsn-select>
            <dsn-input
                class="full-width"
                label="WhatsApp"
                type="text"
                [ngxMask]="{
                    mask: currentDdi.mask,
                    showMaskTyped: true
                }"
                [(ngModel)]="data.whatsapp"
            ></dsn-input>
        </div>

        <div class="edit-whatsapp-dialog__content-remember">
            <i
                class="fa-solid fa-info-circle"
                [matTooltip]="tooltipMessage"
            ></i>
            <span class="edit-whatsapp-dialog__content-remember-text">
                Caso não queira utilizar essa opção, basta deixar em branco.
            </span>
        </div>

        <div class="edit-whatsapp-dialog__content-show-message">
            <dsn-checkbox
                [(ngModel)]="data.showMessage"
                (ngModelChange)="onChange($event)"
            ></dsn-checkbox>
            <span class="edit-whatsapp-dialog__content-show-message-text"
                >Não mostrar esta mensagem novamente.</span
            >
        </div>
    </div>
    <div class="edit-whatsapp-dialog__actions">
        <dsn-button
            [prelabel]=""
            [label]="'Cadastrar depois'"
            [type]="'secondary'"
            [size]="'medium'"
            [disabled]="false"
            [iconLeft]=""
            [iconRight]=""
            [active]="false"
            (onClick)="onClose()"
        ></dsn-button>
        <dsn-button
            [prelabel]=""
            [label]="'Salvar'"
            [type]="'primary'"
            [size]="'medium'"
            [disabled]="loading"
            [iconLeft]=""
            [iconRight]=""
            [active]="false"
            (onClick)="onSave()"
        ></dsn-button>
    </div>
</div>
